var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComplaint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4696 4963 c-65 -22 -147 -98 -177 -165 l-24 -53 0 -1915 0 -1915 28 -57 c117 -239 449 -241 567 -3 l25 50 0 1925 0 1925 -25 50 c-70 143 -237 210 -394 158z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3325 4189 c-440 -136 -875 -272 -967 -300 l-168 -52 0 -1009 c0 -554 2 -1008 5 -1008 3 0 440 -122 972 -270 531 -149 970 -270 975 -270 4 0 8 711 8 1580 0 1258 -3 1580 -12 1579 -7 -1 -373 -113 -813 -250z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805 3768 c-57 -44 -55 -14 -54 -940 0 -634 3 -862 12 -887 7 -19 25 -44 40 -55 28 -21 37 -21 535 -21 l507 0 3 963 2 962 -509 0 c-506 0 -508 0 -536 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 3285 l-25 -24 0 -461 0 -461 25 -24 c23 -24 28 -25 178 -25 141 0 157 2 181 21 l26 20 0 469 0 469 -26 20 c-24 19 -40 21 -181 21 -150 0 -155 -1 -178 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060 908 c0 -575 2 -616 19 -653 36 -77 102 -115 201 -115 99 0 165 38 201 115 17 37 19 78 19 653 l0 612 -220 0 -220 0 0 -612z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1850 870 l0 -170 63 0 c74 0 121 22 154 70 86 125 -12 270 -181 270 l-36 0 0 -170z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplaint);
export default __webpack_public_path__ + "static/media/complaint.a3bdb9ca1c4b0d7f6440303553d00542.svg";
export { ForwardRef as ReactComponent };